export const Bio = {
  name: "Akshat Kumar",
  roles: [
    "Software Developer",
    "Full Stack Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I develop web applications & Solutions for Real World Problems.",
  github: "https://github.com/Akshat-Kumar-X",
  resume:
    "https://drive.google.com/file/d/1-5WIFCOBBkDyfQ_nx0UKsQOrp8e_b4wT/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/akshat-kumar-86203224a/",
  twitter: "https://twitter.com",
  insta: "https://www.instagram.com/akshat_kumar_0/",
  facebook: "https://www.facebook.com/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Tailwind",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTSDKn3vA2YUbXzN0ZC3gALWJ08gJN-Drl15w&s",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Figma",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-brands-in-colors/3000/figma-logo-512.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://cdn-icons-png.flaticon.com/512/5968/5968322.png",
      },
      {
        name: "Express Js",
        image:
          "https://static-00.iconduck.com/assets.00/node-js-icon-454x512-nztofx17.png",
      },
      {
        name: "TypeScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/768px-Typescript_logo_2020.svg.png",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "PHP",
        image:
          "https://static-00.iconduck.com/assets.00/php-icon-256x256-oq5bc0bt.png",
      },
      {
        name: "Rest API",
        image:
          "https://media.licdn.com/dms/image/C5112AQF49DOfOhCFSA/article-cover_image-shrink_720_1280/0/1579816811751?e=2147483647&v=beta&t=e47GGJDzoqsm4dl3qV2EjVWrxyMzIwsPmEE9Gywo83w",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "DSA",
        image: "https://cdn-icons-png.freepik.com/512/8637/8637656.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://d3gih7jbfe3jlq.cloudfront.net/AWS-Podcast-Title-Art.jpg",
      },
      {
        name: "Azure",
        image: "https://cdn.worldvectorlogo.com/logos/azure-1.svg",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Jenkins",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Jenkins_logo.svg/1483px-Jenkins_logo.svg.png",
      },
      {
        name: "Kubernetes",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
      },
      {
        name: "Prometheus",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Prometheus_software_logo.svg/1200px-Prometheus_software_logo.svg.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Version Control",
        image: "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
      },
      {
        name: "GitHub",
        image:
          "https://cdn.pixabay.com/photo/2022/01/30/13/33/github-6980894_1280.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "C/C++",
        image:
          "https://raw.githubusercontent.com/isocpp/logos/master/cpp_logo.png",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Java",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/181_Java_logo_logos-512.png",
      },
      {
        name: "Vercel",
        image: "https://i.ibb.co/kHs9k13/vercel.png",
      },
    ],
  },
];

export const experiences = [
   {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/D560BAQFhe8nBzHDB5Q/company-logo_200_200/B56ZVE0JREGsAM-/0/1740616275287/western_digital_logo?e=1756339200&v=beta&t=K7I2_1lP-5OQ5E5hwd3DJgnYkXVX0SZl0meqGW8Dp80",
    role: "Software Development Intern",
    company: "Western Digital",
    date: "May 2025 - Present",
    desc: "• Containerized distributed microservices using Docker; automated deployments via CI/CD (Jenkins). • Integrated Grafana, Splunk and Prometheus for real-time data analysis and system monitoring. • Designed and deployed cloud-native workloads on AWS (EC2, S3, Lambda, RDS) reducing latency by 25 ms.",
    skills: [
      "Docker",
      "Jenkins",
      "Splunk",
      "AWS",
      "AI intigration",
      "Data Analytics",
      "Application Monitoring",
    ],
    doc: "https://drive.google.com/file/d/1TAAR5s_mcMhMXOxkmP2YD0lFJAjxTSMB/view?usp=sharing",
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/C560BAQFsvADfvcJi_A/company-logo_200_200/company-logo_200_200/0/1676336400451/samsung_electronics_logo?e=1756339200&v=beta&t=IFxpV4IOc-mIOlSO1LDZuZ6SxaAte3PjqrbOLh3eeLo",
    role: "Research & Development Intern",
    company: "Samsung - Bangalore",
    date: "Sep 2024 - May 2025",
    desc: "• Developing a Smart App to seamlessly integrate IoT devices, enabling efficient data transfer to backend.\n• Designing Node.js Backend and RESTful APIs to calculate AQI based on real-time data from sensors.",
    skills: [
      "Java",
      "Node JS",
      "Spring Boot",
      "Application Development",
      "JDBC",
      "MySQL",
      "OOPs",
    ],
    doc: "https://drive.google.com/file/d/1TAAR5s_mcMhMXOxkmP2YD0lFJAjxTSMB/view?usp=sharing",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRAiWQFdQJcY_VvYiPBuISydgF1awsHGUIvPpUgTfwKskmGHovid2tzkLsnjHESh67xttM&usqp=CAU",
    role: "SWE Intern",
    company: "Coforge",
    date: "June 2024 - August 2024",
    desc: "• Developed a robust web scraper to automate data extraction from web sources using Spring Boot.\n• Designed modules to optimize web crawler, capable of crawling up to 3 levels.\n• Created RESTful APIs for seamless data exchange and implemented MySQL Database CRUD operations.",
    skills: [
      "Spring",
      "Spring Boot",
      "Java",
      "Hibernate",
      "JDBC",
      "MySQL",
      "OOPs",
    ],
    doc: "https://drive.google.com/file/d/1TAAR5s_mcMhMXOxkmP2YD0lFJAjxTSMB/view?usp=sharing",
  },
  {
    id: 3,
    img: "https://i.ibb.co/Y7n34K4/Unified-Mentor.png",
    role: "Full Stack Engineering Intern",
    company: "Unified Mentor",
    date: "June 2024 - July 2024",
    desc: "• Developed a full stack scalable platform to connect users using MERN stack and Redux.\n• Optimized the platform's performance by 40%, reducing loading time and enhancing user experience.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Tailwind",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "https://drive.google.com/file/d/1TAAR5s_mcMhMXOxkmP2YD0lFJAjxTSMB/view?usp=sharing",
  },
  {
    id: 5,
    img: "https://i.ibb.co/R4gdCch/iquest.png",
    role: "Technical Head",
    company: "Innovator's Quest",
    date: "Dec 2023 - Present",
    desc: "As the Technical Head of Innovator's Quest Club, I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with iQuest, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
    skills: [
      "Leadership",
      "Team Work",
      "Event Management",
      "Full Stack Development",
    ],
    doc: "https://drive.google.com/file/d/1wb3WOT0dWL5OIZ53xEROxnFdj0xC8fxO/view?usp=sharing",
  },
];

export const education = [
  {
    id: 0,
    img: "https://i.ibb.co/BnFvKqG/vit.png",
    school: "Vellore Institute of Industrial Technology, Vellore",
    date: "Sept 2022 - May 2026",
    grade: " 8.72 CGPA",
    desc: "Pursuing Bachelor's degree in Computer Science and Engineering at Vellore Institute of Industrial Technology, Vellore. Relevent courses are: Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://i.ibb.co/Yf3DP0L/school.png",
    school: "ST Teresa School",
    date: "Apr 2021 - Apr 2022",
    grade: "86.5%",
    desc: "I completed my class 12 high school education at ST Teresa School, where I studied Science with Computer Science.",
    degree: "CBSE(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://i.ibb.co/Yf3DP0L/school.png",
    school: "ST Teresa School",
    date: "Apr 2019 - Apr 2020",
    grade: "90.2%",
    desc: "I completed my class 10 high school education at ST Teresa School, where I studied Science with Computer Science.",
    degree: "CBSE(X), PCM & CS",
  },
];

export const projects = [
  {
    id: 0,
    title: "Edumate",
    date: "June 2024 - July 2024",
    description:
      "Full Stack Scalable Platform that connects Students with nearby Teachers and tuition centres using React",
    image: "https://i.ibb.co/4RHp55P/Screenshot-2024-07-21-091038.png",
    tags: [
      "React JS",
      "Node Js",
      "Express Js",
      "Mongo DB",
      "Rest API",
      "CRUD",
      "Redux",
      "Tailwind",
    ],
    category: "Full Stack app",
    github: "https://github.com/Akshat-Kumar-X/Edumate",
    webapp: "https://edumate-tutor.vercel.app/",
  },
  {
    id: 0,
    title: "PriceWise",
    date: "Dec 2023 - Jan 2024",
    description:
      "E-Commerce Price Tracking Full Stack application using Web Scrapping Technologies as well as Next.js and React.js. Developed a RESTful API to monitor real-time price changes.",
    image: "https://i.ibb.co/cDH84C9/Screenshot-2024-07-21-092119.png",
    tags: [
      "Web Scraping",
      "Next Js",
      "React JS",
      "Node Js",
      "Express Js",
      "Redux",
      "Tailwind",
      "Cron jobs",
    ],
    category: "Full Stack app",
    github: "https://github.com/Akshat-Kumar-X/pricewise",
    webapp: "https://pricewise-dun.vercel.app/",
  },
  {
    id: 1,
    title: "Rent a Ride",
    date: "Jan 2024 - Feb 2024",
    description:
      "Fully Functional Car Rental Portal using PHP, Bootstrap and MySQL also Created an Admin Panel Implementing CRUD operations to manage rent requests and update cars for rent.",
    image: "https://i.ibb.co/Q8M9gcB/rentaride.png",
    tags: ["PHP", "MySQL", "Bootstrap", "HTML", "CSS", "JavaScript"],
    category: "Full Stack app",
    github: "https://github.com/Akshat-Kumar-X/Rent-A-Car-Portal",
    webapp: "https://rent-a-carr.great-site.net/",
  },
  {
    id: 2,
    title: "AI Meds",
    date: "Feb 2024 - Mar 2024",
    description:
      "Personalized AI Health Care platform for Patients and Doctors using Machine Learning for identifying Diseases and React.js, Executed CRUD operations for seamless Doctor Appointment Scheduling",
    image: "https://i.ibb.co/2KGZ7qZ/aimeds.png",
    tags: [
      "React Js",
      "Machine Learning",
      "Tailwind",
      "App Write",
      "Material UI",
      "NodeMailer",
    ],
    category: "Full Stack app",
    github: "https://github.com/Akshat-Kumar-X/AI-Med",
    webapp: "https://ai-meds.netlify.app/",
  },
  {
    id: 3,
    title: "SumZ",
    date: "Nov 2024 - Dec 2023",
    description:
      "Intelligent Article and Website Summarizer Tool using OpenAI API and React.js Used OpenAI API’s advanced language models and API to generate concise and accurate summaries.",
    image: "https://i.ibb.co/MNjq1V8/sumz.png",
    tags: ["React JS", "Open AI", "Redux Toolkit", "API", "Tailwind", "CSS3"],
    category: "Full Stack app",
    github: "https://github.com/Akshat-Kumar-X/SumZ",
    webapp: "https://sumz-openai-summerizer.netlify.app/",
  },
  {
    id: 4,
    title: "Metaverse",
    date: "Sept 2023 - Oct 2023",
    description:
      "Responsive Front End Web application using Framer Motion and React.js interactive Front-End experience using advanced Framer Motion animations, focusing on modern UI/UX principles",
    image: "https://i.ibb.co/xJDVjNY/metaverse.png",
    tags: [
      "Next JS",
      "Framer Motion",
      "Tailwind",
      "Material UI",
      "UI/UX",
      "Responsive",
      "Figma",
    ],
    category: "Frontend app",
    github: "https://github.com/Akshat-Kumar-X/Metaverse",
    webapp: "https://metaverse-world-madness.vercel.app/",
  },
  {
    id: 5,
    title: "Fintech Mart",
    date: "Oct 2023 - Nov 2023",
    description:
      "Implemented cutting-edge design techniques to deliver a seamless browsing experience with cross-browser compatibility. Engineered a visually stunning and responsive user interface.",
    image: "https://i.ibb.co/0mxRfGy/finance.png",
    tags: [
      "Next JS",
      "Framer Motion",
      "Tailwind",
      "Material UI",
      "UI/UX",
      "Responsive",
      "Figma",
    ],
    category: "Frontend app",
    github: "https://github.com/Akshat-Kumar-X/Batch-System",
    webapp: "https://akshat-batch-systems.vercel.app/",
  },
  {
    id: 6,
    title: "Grow with Data",
    date: "Aug 2023 - Sept 2023",
    description:
      "Data Analytics Dashboard showcasing the power of data visualization. Built with React.js and Tailwind, this application helps users make informed decisions by providing clear and interactive data presentations.",
    image: "https://i.ibb.co/yVyH7rh/grow.png",
    tags: [
      "React JS",
      "Tailwind",
      "Material UI",
      "UI/UX",
      "Responsive",
      "Figma",
    ],
    category: "Frontend app",
    github: "https://github.com/Akshat-Kumar-X/DataAnalytics",
    webapp: "https://grow-with-data.netlify.app/",
  },
  {
    id: 7,
    title: "PokeDex",
    date: "Aug 2023 - Sept 2023",
    description:
      "Interactive PokeDex application allowing users to search and view details of various Pokemon. Built with React.js, Tailwind, and Material UI for a smooth and responsive user experience.",
    image: "https://i.ibb.co/3pF4DM3/PokeDex.png",
    tags: [
      "React JS",
      "Tailwind",
      "Material UI",
      "UI/UX",
      "Responsive",
      "Figma",
    ],
    category: "Web games",
    github: "https://github.com/Akshat-Kumar-X/PokeDex",
    webapp: "https://poke-dexx.vercel.app/",
  },
  {
    id: 8,
    title: "SimonGame",
    date: "April 2023 - May 2023",
    description:
      "Classic Simon game recreated using React.js. Test your memory skills with this fun and interactive game, featuring smooth animations and responsive design.",
    image: "https://i.ibb.co/QFDCbs8/Screenshot-2024-06-10-155045.png",
    tags: ["JavaScript", "AJAX", "jQuery", "HTML5", "CSS3"],
    category: "Web games",
    github: "https://github.com/Akshat-Kumar-X/SimonGame",
    webapp: "https://akshat-kumar-x.github.io/SimonGame/",
  },
  {
    id: 9,
    title: "DiceGame",
    date: "April 2023 - May 2023",
    description:
      "Simple Dice Game created with React.js. Roll the dice and try your luck in this easy-to-play game with a clean and responsive interface.",
    image: "https://i.ibb.co/WDBCBhJ/Screenshot-2024-06-10-201218.png",
    tags: ["JavaScript", "AJAX", "jQuery", "HTML5", "CSS3"],
    category: "Web games",
    github: "https://github.com/Akshat-Kumar-X/Dice-Game",
    webapp: "https://akshat-kumar-x.github.io/Dice-Game/",
  },
];
